import { render, staticRenderFns } from "./documents.accountspayable.pending.vue?vue&type=template&id=356fa827&scoped=true"
import script from "./documents.accountspayable.pending.vue?vue&type=script&lang=js"
export * from "./documents.accountspayable.pending.vue?vue&type=script&lang=js"
import style0 from "./documents.accountspayable.pending.vue?vue&type=style&index=0&id=356fa827&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356fa827",
  null
  
)

export default component.exports